<ng-container *transloco="let t">
	<button [matMenuTriggerFor]="menu" aria-label="{{ t('UI.select_language') }}" class="block appearance-none bg-transparent text-sm text-gray-700 focus:outline-none">
		<fa-icon class="block text-lg sm:text-2xl xl:hidden" [icon]="faLanguage"></fa-icon>
		<span class="hidden xl:block"
			>{{ t('UI.language') }}: <span class="text-blue-500">{{ activeLanguage }}</span></span
		>
	</button>
	<mat-menu [class]="'mat-menu-panel--lang px-4 py-1'" xPosition="before" #menu="matMenu">
		<ng-container>
			<nav class="grid grid-cols-1 px-6 py-4">
				<button
					lang="en"
					class="group flex appearance-none flex-row items-center justify-between border-0 border-b border-solid border-gray-300 bg-transparent pb-3 text-sm font-semibold text-gray-700 hover:text-blue-500"
					(click)="select('en')"
				>
					<span class="flex-1 text-left">English</span>
					<i class="broder-solid ml-2 h-6 w-6 overflow-hidden rounded-full border border-gray-400 shadow-none transition-shadow duration-200 ease-in-out group-hover:shadow-lg">
						<img src="assets/images/flags/vereinigte-staaten.png" class="h-full w-full" alt="{{ t('UI.english') }}" />
					</i>
				</button>
				<button
					lang="de"
					class="group flex appearance-none flex-row items-center justify-between border-0 border-b border-solid border-gray-300 bg-transparent py-3 text-sm font-semibold text-gray-700 hover:text-blue-500"
					(click)="select('de')"
				>
					<span class="flex-1 text-left">Deutsch</span>
					<i class="broder-solid ml-2 h-6 w-6 overflow-hidden rounded-full border border-gray-400 shadow-none transition-shadow duration-200 ease-in-out group-hover:shadow-lg">
						<img src="assets/images/flags/deutschland.png" class="h-full w-full" alt="{{ t('UI.german') }}" />
					</i>
				</button>
				<button
					lang="fr"
					class="group flex appearance-none flex-row items-center justify-between border-0 border-b border-solid border-gray-300 bg-transparent py-3 text-sm font-semibold text-gray-700 hover:text-blue-500"
					(click)="select('fr')"
				>
					<span class="flex-1 text-left">Français</span>
					<i class="broder-solid ml-2 h-6 w-6 overflow-hidden rounded-full border border-gray-400 shadow-none transition-shadow duration-200 ease-in-out group-hover:shadow-lg">
						<img src="assets/images/flags/frankreich.png" class="h-full w-full" alt="{{ t('UI.french') }}" />
					</i>
				</button>
				<button
					lang="es"
					class="group flex appearance-none flex-row items-center justify-between border-0 bg-transparent pb-1 pt-3 text-sm font-semibold text-gray-700 hover:text-blue-500"
					(click)="select('es')"
				>
					<span class="flex-1 text-left">Español</span>
					<i class="broder-solid ml-2 h-6 w-6 overflow-hidden rounded-full border border-gray-400 shadow-none transition-shadow duration-200 ease-in-out group-hover:shadow-lg">
						<img src="assets/images/flags/spanien.png" class="h-full w-full" alt="{{ t('UI.spanish') }}" />
					</i>
				</button>
			</nav>
		</ng-container>
	</mat-menu>
</ng-container>
